module.exports = __webpack_public_path__ + "static/media/03_plantilla_combo_rectangular_marco_comida_11.c75a05b2.png";